import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const IkanKelompok = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [ikanKelompok, setIkanKelompok] = useState('')

    useEffect(() => {
        const getIkanKelompok = async () => {
            try {
                const response = await masterService.getKelompokIkan(id)
                setIkanKelompok(response.data.nmKelIkan)
            } catch (error) {
                setIkanKelompok('')
            }
        }
        getIkanKelompok()
    }, [masterService, id])

    return (
        <>
            {ikanKelompok}
        </>
    )
}

export default IkanKelompok